import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const ProductsIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/products'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'settings_products', params: to.params }),
        },
        {
          path: 'list',
          name: 'settings_products',
          component: ProductsIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
